var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 121,
    viewBox: "0 0 87 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.4149L0.639234 95.8635L43.268 120.634L42.6687 61.1852L0 36.4149Z",
    fill: "#D6DBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6687 61.1852L43.268 120.634L86.1764 95.8635L85.5772 36.4149L42.6687 61.1852Z",
    fill: "#BBC3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.4149L42.6687 61.1851L85.5772 36.4149L42.9484 11.6447L0 36.4149Z",
    fill: "#F0F1F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2052 7.36983L56.572 4.13373C56.4122 4.01387 56.1725 4.01387 55.8928 4.09377L61.5261 7.36983C61.8057 7.24997 62.0454 7.28993 62.2052 7.36983Z",
    fill: "#D6DBF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2052 7.36983L56.572 4.13373C56.4122 4.01387 56.1725 4.01387 55.8928 4.09377L61.5261 7.36983C61.8057 7.24997 62.0454 7.28993 62.2052 7.36983Z",
    fill: "#D6DBF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4046 43.1668L35.0379 46.4429C34.7582 46.2831 34.5984 45.9235 34.6383 45.4041L29.0051 42.1281C28.9651 42.6474 29.125 43.007 29.4046 43.1668Z",
    fill: "#D6DBF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6383 45.4041L29.0051 42.1281C28.9651 42.6474 29.125 43.007 29.4046 43.1668L35.0379 46.4429C34.7582 46.2831 34.5984 45.9235 34.6383 45.4041Z",
    fill: "#D6DBF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.526 7.36993L55.8927 4.09387L46.6638 7.29003L52.2971 10.5661L61.526 7.36993Z",
    fill: "#D6DBF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9846 7.25L51.6179 10.5261C51.7777 10.6459 52.0174 10.6459 52.297 10.566L46.6638 7.28995C46.3841 7.36986 46.1444 7.36986 45.9846 7.25Z",
    fill: "#D6DBF2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.297 10.566L46.6638 7.28995C46.3841 7.36986 46.1444 7.36986 45.9846 7.25L51.6179 10.5261C51.7777 10.6459 52.0174 10.6459 52.297 10.566Z",
    fill: "#D6DBF2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7168 34.0178L30.0836 30.7817L29.0049 42.1281L34.6381 45.4042L35.7168 34.0178Z",
    fill: "#D6DBF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3574 33.0191L29.7241 29.743C30.0038 29.9028 30.1236 30.3024 30.0837 30.7818L35.7169 34.0179C35.7569 33.5784 35.637 33.1789 35.3574 33.0191Z",
    fill: "#D6DBF2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3574 33.0191L29.7241 29.743C30.0038 29.9028 30.1236 30.3024 30.0837 30.7818L35.7169 34.0179C35.7569 33.5784 35.637 33.1789 35.3574 33.0191Z",
    fill: "#D6DBF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.792 16.9984L34.1587 13.7223C33.9989 14.2417 33.6394 14.7211 33.2798 15.0007L38.913 18.2768C39.2726 17.9572 39.5922 17.5177 39.792 16.9984Z",
    fill: "#D6DBF2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.792 16.9984L34.1587 13.7223C33.9989 14.2417 33.6394 14.7211 33.2798 15.0007L38.913 18.2768C39.2726 17.9572 39.5922 17.5177 39.792 16.9984Z",
    fill: "#D6DBF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.504 3.37467L40.9107 0.0986114C40.6311 -0.0611965 40.2715 -0.0212519 39.9519 0.178508L45.5851 3.45458C45.9048 3.25482 46.2643 3.21486 46.504 3.37467Z",
    fill: "#D6DBF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.504 3.37467L40.9107 0.0986114C40.6311 -0.0611965 40.2715 -0.0212519 39.9519 0.178508L45.5851 3.45458C45.9048 3.25482 46.2643 3.21486 46.504 3.37467Z",
    fill: "#D6DBF2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3866 4.93281L38.7534 1.65674L34.1589 13.7222L39.7922 16.9983L44.3866 4.93281Z",
    fill: "#D6DBF2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.585 3.45454L39.9517 0.178467C39.4723 0.458131 39.0328 0.977512 38.7532 1.6567L44.3864 4.93276C44.6661 4.25358 45.1055 3.7342 45.585 3.45454Z",
    fill: "#D6DBF2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.585 3.45454L39.9517 0.178467C39.4723 0.458131 39.0328 0.977512 38.7532 1.6567L44.3864 4.93276C44.6661 4.25358 45.1055 3.7342 45.585 3.45454Z",
    fill: "#D6DBF2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.965 28.7442L23.3318 25.4681L29.7241 29.743L35.3573 33.0191L28.965 28.7442Z",
    fill: "#D6DBF2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9132 18.2768L33.2799 15.0007L24.051 22.4717L29.6843 25.7478L38.9132 18.2768Z",
    fill: "#D6DBF2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5852 3.45457C45.1058 3.73424 44.6663 4.25362 44.3866 4.9328L39.7921 16.9983C39.5924 17.5177 39.2728 17.9571 38.9132 18.2768L29.6843 25.7478C28.6455 26.5868 28.246 28.2648 28.9651 28.7442L35.3575 33.019C35.6371 33.1789 35.757 33.5784 35.717 34.0178L34.6383 45.4042C34.5584 46.403 35.2376 46.8025 35.9967 46.363C36.1831 46.2565 36.3696 46.0967 36.556 45.8836L45.1058 36.4549C45.2922 36.2418 45.4786 36.082 45.6651 35.9755C45.8515 35.869 46.038 35.8157 46.2244 35.8157L54.7741 35.3762C54.9606 35.3496 55.147 35.283 55.3335 35.1765C56.0926 34.737 56.7717 33.5784 56.6918 32.6595L55.5732 22.5516C55.5332 22.1521 55.6531 21.6327 55.8928 21.1533L62.2452 9.52728C62.9643 8.20887 62.5648 7.0103 61.526 7.36986L52.2971 10.566C51.8976 10.6859 51.578 10.606 51.3782 10.3263L46.7438 3.57443C46.4641 3.17491 46.0247 3.17491 45.5852 3.45457Z",
    fill: "#BBC3E9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6842 25.7477L24.051 22.4717C23.0122 23.3107 22.6127 24.9887 23.3318 25.4681L28.9651 28.7441C28.2459 28.2647 28.6455 26.5867 29.6842 25.7477Z",
    fill: "#D6DBF2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6842 25.7477L24.051 22.4717C23.0122 23.3107 22.6127 24.9887 23.3318 25.4681L28.9651 28.7441C28.2459 28.2647 28.6455 26.5867 29.6842 25.7477Z",
    fill: "#D6DBF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRate);
export default __webpack_public_path__ + "static/media/low-rate.8c22a405f4a37062013226776d6481c4.svg";
export { ForwardRef as ReactComponent };